import { render, staticRenderFns } from "./UploadedFilesView.vue?vue&type=template&id=64854655&scoped=true&"
import script from "./UploadedFilesView.vue?vue&type=script&lang=ts&"
export * from "./UploadedFilesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64854655",
  null
  
)

export default component.exports